import { render, staticRenderFns } from "./login-signup.vue?vue&type=template&id=0696139f&scoped=true&"
import script from "./login-signup.vue?vue&type=script&lang=js&"
export * from "./login-signup.vue?vue&type=script&lang=js&"
import style0 from "./login-signup.vue?vue&type=style&index=0&id=0696139f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696139f",
  null
  
)

/* custom blocks */
import block0 from "./login-signup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports